import React from 'react';

// components
import Dropdown from 'react-bootstrap/Dropdown';

// styles
import styles from "../AddMeeting/AddMeeting.module.css"

//Images
import arrowDown from "../../../../assets/img/DashboardICons/ArrowDown.svg"

const AddMeetingInputDropDown = (props) => {

    return (
        <>
            <style type="text/css">
                {`
    .dropdown-toggle {
        width: 510px;
        height: 48px;
        padding-right: 10px;
        padding-left: 10px;
        background: #ffffff;
        border: 1px solid #e1e1e1;
        border-radius: 24px;
        text-align: right;
        color: #1D1D1D;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    
    .dropdown-toggle:after,
    .btn-success:after {
        content: none;
    }
    
    .btn-success {
        background: #ffffff !important;
        border: 1px solid #E1E1E1 !important;
        color: #8D8D8D !important;
        box-shadow: none !important;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
    }

    .dropdown-menu {
        width: 510px;
        padding-right: 10px;
        padding-left: 10px;
        height: 120px !important;
        overflow-y: scroll;
        background: #ffffff;
        border: 1px solid #E1E1E1;
        border-radius: 24px;
    }

   .dropdown-menu::-webkit-scrollbar{
    width: 4px;
    height: 60px;
    }
    
    .dropdown-menu::-webkit-scrollbar-track {
        background: transparent;
        margin-block: 10px;
    }

    .dropdown-menu::-webkit-scrollbar-thumb {
        background: #B4B4B4;
        border-radius: 20px;
    }

    .dropdown-item {
        margin: .5rem 0;
        padding: .5rem .5rem .5rem 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #363636;
    }

    .dropdown-item:hover {
        background: transparent !important;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #21409A;
    }
    `}
            </style>

            <div className={`position-relative d-flex align-items-start justify-content-center flex-column my-1 ${props.fullWidth && "w-100"}`}>
                <div className={`mb-3 ${styles.input_top_title}`}>
                    {props.defaultText}
                </div>
                <Dropdown dir='rtl'>
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                        {props.selectedItem ? props.selectedItem : props.defaultText}
                        <img className='me-3' src={arrowDown} alt="icon" />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        {props.users?.map((item) => (
                            <Dropdown.Item className="d-flex justify-content-between" id="parent" key={item.id} name={item.fullName} onClick={() => titleHandler(item.fullName, props.defaultText, item.id)}>
                                {item.fullName}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
                {props.meetingResponsible &&
                    <div className={styles.text_danger}>
                        مسئول نوشتن نتیجه جلسه
                    </div>
                }
            </div>
        </>
    );

    function titleHandler(name, defaultText, id) {
        props.setState((prev) => {
            return { ...prev, [props.inputName]: name };
        });
        if (defaultText === "رئیس جلسه") {
            props.setState((prev) => {
                return { ...prev, managerID: id };
            });
        } else if (defaultText === "ناظر") {
            props.setState((prev) => {
                return { ...prev, supervisorID: id };
            });
        } else if (defaultText === "مسئول صورت جلسه") {
            props.setState((prev) => {
                return { ...prev, meetingResponsibleID: id };
            });
        }
    };
};

export default AddMeetingInputDropDown;